import { createFileRoute, notFound } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/friend/$friendId")({
	params: {
		parse: (raw) => {
			const friendId = Number(raw.friendId)
			if (!Number.isFinite(friendId)) throw notFound()
			return { friendId }
		},
		stringify: (parsed) => ({ friendId: String(parsed.friendId) }),
	},
})
